import { useState } from "react";
import { faqItems } from "@/mocks/comicHelp";

export default function Faq() {
  const [open, setOpen] = useState<number>(0);

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqItems.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section id="faq" className="scroll-mt-20 bg-background-50 py-14 md:py-20">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="container-x grid gap-10 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-4 py-1.5 text-sm font-medium text-primary-700">
            <i className="ri-question-answer-line"></i>
            常见问题
          </span>
          <h2 className="mt-4 font-heading text-2xl text-foreground-950 md:text-3xl">
            大家都在问这些
          </h2>
          <p className="mt-3 text-base leading-relaxed text-foreground-700">
            我们整理了读者最常遇到的疑问与解答。如果你还有其他问题，可以继续下翻到联系表单提交，我们会尽快回复。
          </p>
          <a
            href="#contact"
            className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-chat-3-line"></i>
            提交你的问题
          </a>
        </div>

        <div className="lg:col-span-3">
          <div className="space-y-3">
            {faqItems.map((item, idx) => {
              const isOpen = open === idx;
              return (
                <div
                  key={item.q}
                  className="overflow-hidden rounded-xl border border-background-200 bg-background-100/60"
                >
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? -1 : idx)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="flex items-center gap-3 text-base font-semibold text-foreground-950">
                      <i className={`ri-question-line ${isOpen ? "text-primary-600" : "text-secondary-500"}`}></i>
                      {item.q}
                    </span>
                    <i
                      className={`shrink-0 text-lg text-foreground-500 transition-transform ${
                        isOpen ? "rotate-45 text-primary-600" : ""
                      } ri-add-line`}
                    ></i>
                  </button>
                  {isOpen && (
                    <div className="border-t border-background-200 px-5 py-4">
                      <p className="text-sm leading-relaxed text-foreground-700">{item.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}